import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { environmentLoader as environmentLoaderPromise } from './app/services/environment-loader.service';

environmentLoaderPromise.then(env => {
  if (environment.production) {
    enableProdMode();
  }
  environment.settings = env.settings;

  platformBrowserDynamic().bootstrapModule(AppModule);
});